export const EMPLOYEE_PROFILE_BY_RELATION_FIELD_ID = {
    '68988c03-3b65-4b90-a53a-f4114d9c46bc': 1,
    '5b5c42ce-0232-43c3-816a-154840dc2b2c': 2,
    '0543ff8b-36bb-4638-b7f6-641484b3ca4b': 3,
    'bef9f50d-9002-40a0-816f-13c2b507f9f4': 4,
    '69ae92f6-cf99-4bf8-9503-f47311fc401d': 5,
    'd2876d8b-5157-4c2d-9a19-dcd6aedfd985': 6, // Senior user
};
